<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getAgents()">
                                        </vue-search>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Distributor</th>
                                                <th>Total Slot</th>
                                                <th>Total Event</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in agents.data" :key="data.id" v-on:click="eventAgents(data)">
                                                <td width="200px" v-on:click.stop="">
                                                     <b-dropdown id="dropdown-left" text="Settings" variant="primary" class="mt-2 mb-2">
                                                        <template #button-content>
                                                            Settings <i class="uil uil-angle-down"></i>
                                                        </template>

                                                        <b-dropdown-item href="#" @click.prevent="addSlots(data)">Add Slot</b-dropdown-item>
                                                        <b-dropdown-item href="#" @click.prevent="showChallenge(data)">Show Challenge</b-dropdown-item>
                                                    </b-dropdown>
                                                </td>
                                                <td>
                                                    <div>{{data.name}}</div>
                                                    <small>Tier : {{data.tier}}</small>
                                                </td>
                                                <td>{{data.email}}</td>
                                                <td>
                                                    <template v-if="data.distributor">
                                                        <div><strong>Name</strong> : {{data.distributor.name}}</div>
                                                        <div><strong>Email</strong> :{{data.distributor.email}}</div>
                                                    </template>
                                                    <template v-if="!data.distributor">-</template>
                                                </td>
                                                <th><label class="badge badge-success">{{data.slots}} Slot</label></th>
                                                <td><label class="badge badge-primary">{{data.events_count}} Event</label></td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="agents.total === 0" class="text-center no-data">Agents data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="agents"
                                                :sorting="sorting"
                                                @paginate="getAgents()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Agents Data Still Empty</h2>
                                    <p>You can add agent data first after you manage agent slot</p>
                                    <div class="tabel-action">
                                        <router-link class="btn btn-new" :to="{ name: 'agent' }">
                                            <i class="uil uil-plus mr-2"></i>
                                            Add Agents
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form @getAgentsModal="getAgentsModal" @getAgents="getAgents()"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../slot-agent/ModalForm.vue'
    import moment from 'moment'

    export default {
        name: "agents",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getAgents().then(() => {
                if(this.agents.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('AgentsControl', {
                agents: state => state.agents,
                events_agent: state => state.events_agent,
                sorting: state => state.sorting
            }),
        },
        methods: {
            ...mapActions('AgentsControl', ['getAgents']),
            ...mapMutations('AgentsControl', ['ASSIGN_FORM','ASSIGN_DATA_AGENTS','CLEAR_AGENTS','ASSIGN_DATA_EVENTS_AGENTS']),
            
            showChallenge:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Challenge')
            },
            getAgentsModal:function(){
                this.getAgents().then(() => {
                    this.agents.data.forEach(agent => {
                        if(agent.id == this.events_agent.id){
                            this.ASSIGN_DATA_EVENTS_AGENTS(agent)
                        }
                   });

                })
            },
            eventAgents:function(data){
                this.ASSIGN_DATA_EVENTS_AGENTS(data)
                this.$bvModal.show('modal-Event-Agent')
            },
            addSlots:function(data){
                this.ASSIGN_DATA_AGENTS(data)
                this.$bvModal.show('modal-Add-Slots')
            },
        },
        destroyed(){
            this.CLEAR_AGENTS()
        }
    };

</script>
